import React from "react";
import { createRoot } from "react-dom/client";
import EshopBasketApp from "./EshopBasketApp";
import BasketPageTypeConfig from "./BasketPageTypeConfig";
import elementService from "@/common/ElementService";

export default class ProductBasketPageService {
    public init(pageTypeConfig: BasketPageTypeConfig): void {
        createRoot(elementService.querySelector<HTMLDivElement>("#js-basket-page-container"))
            .render(<EshopBasketApp checkoutOrderModel={pageTypeConfig.checkoutModel} />);
    }
}
